import React from 'react';
import { Switch, Route, useRouteMatch } from 'react-router-dom';
import CreateAgent from 'pages/SuperAdmin/Agents/CreateAgent';
import UpdateAgent from 'pages/SuperAdmin/Agents/UpdateAgent';

const SuperAdminAgentsRouter = () => {
  const match = useRouteMatch();
  return (
    <Switch>
      <Route exact path={`${match.path}/new`}>
        <CreateAgent />
      </Route>
      <Route exact path={`${match.path}/updateAgent/:agentId`}>
        <UpdateAgent />
      </Route>
    </Switch>
  );
};

export default SuperAdminAgentsRouter;
